const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export default (object, name, locale) => object[`${name}${capitalizeFirstLetter(locale)}`] || object[name];